import {RaEvent, RaEventType} from "./RaEvent";

export enum SESSION_STATUS {
    start_booksession,
    modify_booksession,
    close_booksession,
    start_trainingsession,
    close_trainingsession
}
export class SessionEvent extends RaEvent {

    static TYPE:RaEventType = "session_event";

    constructor(private _status:SESSION_STATUS) {
        super(SessionEvent.TYPE)
    }

    public get status():SESSION_STATUS {
        return this._status;
    }
}